import gql from "graphql-tag";

export default gql`
    query ZipGeoJSON($zip: String) {
        zipGeoJson(zipCode: $zip)
    }
`;